/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_Task_Email_UnassignedInputs */

const en_api_error_task_email_unassigned = /** @type {(inputs: Api_Error_Task_Email_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The task has no assignee.`)
};

const pt_br2_api_error_task_email_unassigned = /** @type {(inputs: Api_Error_Task_Email_UnassignedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tarefa não tem responsável.`)
};

/**
* | output |
* | --- |
* | "The task has no assignee." |
*
* @param {Api_Error_Task_Email_UnassignedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const api_error_task_email_unassigned = /** @type {((inputs?: Api_Error_Task_Email_UnassignedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_Task_Email_UnassignedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_task_email_unassigned(inputs)
	return pt_br2_api_error_task_email_unassigned(inputs)
});